import GoogleSheetsIcon from '@/assets/attachments/google_sheets.svg'
import GoogleDocsIcon from '@/assets/attachments/google_docs.svg'
import GoogleSlidesIcon from '@/assets/attachments/google_slides.svg'
import GoogleFormsIcon from '@/assets/attachments/google_forms.svg'
import GoogleDriveIcon from '@/assets/attachments/google_drive.svg'
import PdfIcon from '@/assets/attachments/pdf.svg'
import WebLinkIcon from '@/assets/attachments/web_link.svg'
import { LinkType } from '@/library/utils/urlUtils'

export function getLinkIconSrc(linkType: LinkType): string {
  switch (linkType) {
    case LinkType.GOOGLE_SHEET:
      return GoogleSheetsIcon
    case LinkType.GOOGLE_DOC:
      return GoogleDocsIcon
    case LinkType.GOOGLE_SLIDE:
      return GoogleSlidesIcon
    case LinkType.GOOGLE_FORM:
      return GoogleFormsIcon
    case LinkType.GOOGLE_DRIVE:
      return GoogleDriveIcon
    case LinkType.PDF:
      return PdfIcon
    default:
      return WebLinkIcon
  }
}
